module.exports = __webpack_public_path__ + "img/henry.626d5840.png";